import { createLogic } from 'redux-logic'
import { map } from 'rxjs/operators'
import * as constants from '../constants'

export const setProjectAsFavorite = createLogic({
  type: constants.SET_PROJECT_AS_FAVORITE.ACTION,
  processOptions: {
    successType: constants.SET_PROJECT_AS_FAVORITE.FULFILLED,
    failType: constants.SET_PROJECT_AS_FAVORITE.REJECTED
  },
  process({ http, action }) {

    return http
      .post('/comps/project/favorite', { ...action.payload })
      .pipe(map(http.getBody))
  }
})
